import uuidv4 from 'uuid/v4'
import jwtDecode from 'jwt-decode'
import { getAuthenticatedUser } from 'js/bankrate-utilities'

const getCustomerId = () => {
  const bearerToken = getAuthenticatedUser()
  return bearerToken ? jwtDecode(bearerToken).customer_id : uuidv4()
}

const buildAuthenticatedContextObject = () => {
  const tagular = window._Tagular && _Tagular.webContext
  return !tagular
    ? {}
    : {
      tenantVersion: `0.0.1`,
      appTenantId: `bankrate`,
      userId: getCustomerId(),
      userAgent: tagular.userAgent,
      sessionId: tagular.sessionId,
      instanceId: tagular.instanceId,
      anonymousId: tagular.anonymousId,
      manualInstanceId: uuidv4(),
      pageUrl: window.location.href,
      pageTitle: document.title
    }
}

// prettier-ignore
const tagularAuthenticatedModule = {
  formAuthenticatedStarted(formType, formName, formId, stepName, stepType, stepId) {
    if (!formType || !formName || !formId || !stepName || !stepType || !stepId) {
      throw new Error({
        function: 'tagular_authenticated_module.formAuthenticatedStarted',
        error: 'Missing a required parameter.'
      })
    }

    if (typeof tagular !== 'undefined') {
      tagular('beam', 'FormStarted', {
        '@type': 'redventures.authenticated.v1alpha1.FormStarted',
        formContext: {
          formType: formType,
          formName: formName,
          formId: formId
        },
        stepContext: {
          stepName: stepName,
          stepType: stepType,
          stepId: stepId
        }
      })
    }
  },

  formAuthenticatedSubmitted(formType, formName, formId, stepName, stepType, stepId) {
    if (!formType || !formName || !formId || !stepName || !stepType || !stepId) {
      throw new Error({
        function: 'tagular_authenticated_module.formAuthenticatedSubmitted',
        error: 'All parameters must have values'
      })
    }

    if (typeof tagular !== 'undefined') {
      tagular('beam', 'FormSubmitted', {
        '@type': 'redventures.authenticated.v1alpha1.FormSubmitted',
        formContext: {
          formType: formType,
          formName: formName,
          formId: formId
        },
        stepContext: {
          stepName: stepName,
          stepType: stepType,
          stepId: stepId
        },
      })
    }
  },

  formOutcomeReceived(formType, formName, formId, stepName, stepType, stepId) {
    if (!formType || !formName || !formId || !stepName || !stepType || !stepId) {
      throw new Error({
        function: 'tagular_module.formOutcomeReceived',
        error: 'Missing a required parameter.'
      })
    }

    if (typeof tagular !== 'undefined') {
      tagular('beam', 'FormOutcomeReceived', {
        '@type': 'redventures.authenticated.v1alpha1.FormOutcomeReceived',
        formContext: {
          formType: formType,
          formName: formName,
          formId: formId
        },
        stepContext: {
          stepName: stepName,
          stepType: stepType,
          stepId: stepId
        },
        authenticatedContext: buildAuthenticatedContextObject()
      })
    }
  },

  formErrored(formType, formName, formId, stepName, stepType, stepId) {
    if (!formType || !formName || !formId || !stepName || !stepType || !stepId) {
      throw new Error({
        function: 'tagular_authenticated_module.formErrored',
        error: 'Missing a required parameter.'
      })
    }

    if (typeof tagular !== 'undefined') {
      tagular('beam', 'FormErrored', {
        '@type': 'redventures.authenticated.v1alpha1.FormErrored',
        formContext: {
          formType: formType,
          formName: formName,
          formId: formId
        },
        stepContext: {
          stepName: stepName,
          stepType: stepType,
          stepId: stepId
        },
        authenticatedContext: buildAuthenticatedContextObject()
      })
    }
  }
}

export default tagularAuthenticatedModule
